"use client";

import React, { useRef, useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

interface ProjectTakeawayProps {
  takeaway: string;
  id?: string;
}

const ProjectTakeaway: React.FC<ProjectTakeawayProps> = ({ takeaway, id }) => {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo(
        ".takeaway-content",
        { y: 24, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.6,
          stagger: 0.1,
          ease: "power2.out",
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 85%",
          },
        }
      );
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section ref={sectionRef} id={id} className="py-24 border-t border-[#e8e8e8]">
      <div className="container mx-auto px-4">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-16 items-start">
            {/* Left Column - Title (Full Column) */}
            <div className="flex justify-start">
              <h2 className="takeaway-content text-sm uppercase tracking-[0.15em] text-[#6f6f6f] font-pp-neuebit">
                key takeaway
              </h2>
            </div>

            {/* Right Column - Content (Full Column) */}
            <div className="takeaway-content prose prose-lg max-w-none">
              <p className="text-xl md:text-xl text-[#6b6b6b] leading-relaxed font-neue-regrade-variable">
                {takeaway}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectTakeaway;
